export default __webpack_public_path__ + "media/images/logofluxod-2a5c6c12ba5dec3fa6eb57aea9d2952b.png";